export default {
	ENGAGE_EMAIL: "ENGAGE_EMAIL",
	ENGAGE_SMS: "ENGAGE_EMAIL",
	SET_ENGAGE_CONTACT: "SET_ENGAGE_CONTACT"
};
